import React from 'react';
import { Briefcase, MapPin, Calendar, ExternalLink } from 'lucide-react';
import { workExperience } from '../../mock';

const ExperienceSection = () => {
  return (
    <section id="experience" className="py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-center mb-16">Where I've made an impact</h2>
        
        {/* Vertical Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-0 md:left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#7C3AED] to-transparent" />
          
          {workExperience.map((exp, index) => (
            <div key={exp.id} className="relative pl-8 md:pl-20 pb-12 last:pb-0">
              {/* Timeline Dot */}
              <div className="absolute left-0 md:left-[30px] top-2 w-4 h-4 rounded-full bg-[#7C3AED] border-4 border-[#0E0B1F]" />
              
              {/* Experience Card */}
              <div className="bg-[#1A1430] border border-[#7C3AED]/10 rounded-2xl p-6 md:p-8 hover:border-[#7C3AED]/30 transition-all duration-300">
                <div className="flex flex-wrap items-start justify-between gap-4 mb-4">
                  <div>
                    <h3 className="text-2xl font-semibold text-[#EDE9FE] mb-2" style={{ fontFamily: 'Geist, Inter, sans-serif' }}>
                      {exp.company}
                    </h3>
                    <p className="text-lg text-[#7C3AED] font-medium mb-2">
                      {exp.position}
                    </p>
                    <div className="flex flex-wrap gap-4 text-sm text-[#9D97B5]">
                      <span className="flex items-center gap-1">
                        <MapPin size={16} />
                        {exp.location}
                      </span>
                      <span className="flex items-center gap-1">
                        <Calendar size={16} />
                        {exp.duration}
                      </span>
                    </div>
                  </div>
                  
                  {/* Current Badge */}
                  {exp.current && (
                    <span className="px-4 py-1.5 bg-[#7C3AED]/20 text-[#7C3AED] rounded-full text-sm font-medium border border-[#7C3AED]/30">
                      Current
                    </span>
                  )}
                </div>
                
                {/* Website Link */}
                {exp.website && (
                  <a
                    href={`https://${exp.website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#7C3AED] hover:text-[#C026D3] mb-6 transition-colors"
                  >
                    <ExternalLink size={16} />
                    {exp.website}
                  </a>
                )}
                
                {/* Responsibilities */}
                <ul className="space-y-3">
                  {exp.responsibilities.map((responsibility, idx) => (
                    <li key={idx} className="flex gap-3 text-[#9D97B5] leading-relaxed">
                      <span className="text-[#7C3AED] mt-1.5 flex-shrink-0">•</span>
                      <span>{responsibility}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
